(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-pm-filter]').forEach(button => {
      if (button.dataset.pmBound) return;
      button.dataset.pmBound = 'true';
      button.addEventListener('click', () => {
        const section = button.closest('.shopify-section') || button.closest('section');
        section.querySelectorAll('[data-pm-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        section.querySelectorAll('[data-pm-category]').forEach(card => { card.hidden = button.dataset.pmFilter !== 'all' && card.dataset.pmCategory !== button.dataset.pmFilter; });
      });
    });
    const toggle = root.querySelector('.pm-mobile-toggle');
    if (toggle && !toggle.dataset.pmBound) {
      toggle.dataset.pmBound = 'true';
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      const close = () => { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); menu.hidden = !open; });
      menu.addEventListener('click', e => { if(e.target.closest('a')) close(); });
      toggle.closest('header').addEventListener('keydown', e => { if(e.key === 'Escape' && !menu.hidden) { close(); toggle.focus(); } });
    }
    document.querySelectorAll('.pm-story').forEach(e => e.id = 'studio');
    document.querySelectorAll('.pm-journey-grid').forEach(e => e.closest('section').id = 'verdieping');
  }
  class PoYoMiSearch extends HTMLElement {
    connectedCallback() {
      if(this.bound) return;
      this.bound = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.pm-suggestions');
      this.status = this.querySelector('[data-search-status]');
      this.onInput = () => { clearTimeout(this.timer); this.controller?.abort(); this.hide(); if(this.input.value.trim().length >= 2) this.timer = setTimeout(() => this.search(), 240); };
      this.input.addEventListener('input', this.onInput);
      this.addEventListener('focusout', e => { if(!this.contains(e.relatedTarget)) this.hide(); });
      this.addEventListener('keydown', e => {
        if(e.key === 'Escape') { this.hide(); this.input.focus(); }
        if(e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          const links = Array.from(this.results.querySelectorAll('a'));
          if(!this.results.hidden && links.length) { e.preventDefault(); let i = links.indexOf(document.activeElement); i = e.key === 'ArrowDown' ? (i + 1) % links.length : (i <= 0 ? links.length - 1 : i - 1); links[i].focus(); }
        }
      });
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    hide() { this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
    async search() {
      const term = this.input.value.trim();
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.endpoint, location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'page,product,article');
        url.searchParams.set('resources[limit]', '6');
        if (!url.pathname.endsWith('.json')) url.pathname += '.json';
        const res = await fetch(url, {signal:this.controller.signal});
        if(!res.ok) throw new Error('Search unavailable');
        const data = await res.json();
        if(this.input.value.trim() !== term) return;
        const resources = data.resources?.results || {};
        const items = [...(resources.pages || []), ...(resources.products || []), ...(resources.articles || [])].slice(0, 8);
        if(!items.length) { this.hide(); return; }
        this.results.replaceChildren();
        for(const item of items) {
          const target = new URL(item.url, location.origin);
          if(!['http:','https:'].includes(target.protocol)) continue;
          const a = document.createElement('a');
          a.href = target.pathname + target.search;
          const title = document.createElement('span');
          title.textContent = target.pathname.endsWith('/pages/lessen') ? 'Alle lessen bij PoYoMi' : item.title;
          const label = document.createElement('small');
          label.textContent = target.pathname.includes('/products/') ? 'Aanbod' : target.pathname.includes('/blogs/') ? 'Artikel' : 'Pagina';
          a.append(title, label); this.results.append(a);
        }
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded','true');
        this.status.textContent = `${this.results.querySelectorAll('a').length} resultaten`;
      } catch(e) { if(e.name !== 'AbortError') this.hide(); }
    }
  }
  class PoYoMiHeroVideo extends HTMLElement {
    connectedCallback() {
      if(this.videoBound) return;
      this.videoBound = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.pm-video-control');
      if(!this.video || !this.button) return;
      this.video.muted = true;
      this.userPaused = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoAllowed = !this.reducedMotion.matches && !navigator.connection?.saveData;
      this.button.addEventListener('click', () => {
        if(this.video.paused) { this.userPaused = false; this.playVideo(); }
        else { this.userPaused = true; this.video.pause(); }
      });
      this.video.addEventListener('playing', () => {
        this.video.classList.add('pm-video-ready');
        this.updateControl(true);
      });
      this.video.addEventListener('pause', () => this.updateControl(false));
      this.video.addEventListener('error', () => {
        this.video.classList.remove('pm-video-ready');
        this.button.hidden = true;
      });
      this.motionChange = () => {
        this.autoAllowed = !this.reducedMotion.matches && !navigator.connection?.saveData;
        if(!this.autoAllowed) this.video.pause();
      };
      this.reducedMotion.addEventListener('change', this.motionChange);
      this.observer = new IntersectionObserver(entries => {
        for(const entry of entries) {
          if(entry.isIntersecting && this.autoAllowed && !this.userPaused) this.playVideo();
          else if(!entry.isIntersecting) this.video.pause();
        }
      }, {threshold:0.2});
      this.observer.observe(this);
    }
    async playVideo() {
      try { await this.video.play(); }
      catch { this.updateControl(false); }
    }
    updateControl(playing) {
      const label = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
      this.button.setAttribute('aria-label', label);
      this.button.querySelector('[data-video-label]').textContent = label;
      this.button.querySelector('[data-video-icon]').textContent = playing ? 'Ⅱ' : '▶';
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.reducedMotion?.removeEventListener('change', this.motionChange);
      this.video?.pause();
      this.videoBound = false;
    }
  }
  if(!customElements.get('poyomi-hero-video')) customElements.define('poyomi-hero-video', PoYoMiHeroVideo);
  if(!customElements.get('poyomi-search')) customElements.define('poyomi-search', PoYoMiSearch);
  init();
  document.addEventListener('shopify:section:load', e => {
    init(e.target);
    // The official Momoyoga plugin listens for this jQuery event to initialize new containers.
    if(e.target.querySelector('[data-momo-schedule]:not([data-momo-initialized="true"])') && window.jQuery) {
      window.jQuery(document).triggerHandler('ajaxComplete');
    }
  });
  document.addEventListener('cart:updated', () => {
    const url = (window.theme?.routes?.root || '/') + 'cart.js';
    fetch(url).then(r=>r.json()).then(cart=>document.querySelectorAll('[data-pm-cart-count]').forEach(e=>e.textContent=cart.item_count)).catch(()=>{});
  });
})();
